import { FC, useState } from "react";
import { useFormik } from "formik";
import styles from "./styles.module.scss";
//assets
import Logo from "../../assets/icons/logo.svg";
//api
import { deleteAccount } from "../../services/auth.service";
//components
import { Input, Button } from "../../components";
//schemas
import { signInSchema } from "../../schemas";
import { toast } from "react-hot-toast";

const DeleteAccount: FC = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const onDelete = async (
    values: { email: string; password: string },
    { resetForm }: { resetForm: () => void }
  ) => {
    try {
      setError("");
      setIsLoading(true);
      const { data } = await deleteAccount(values?.email, values?.password);

      if (data?.success) {
        toast.success("Account deleted successfully");
        resetForm();
      }
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      console.log("delete error", error);
      setError(error?.message || "Invalid email address or password.");
      toast.error(error?.message || "Failed to delete account");
    }
  };

  const { values, errors, handleSubmit, handleChange, touched } = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: signInSchema,
    validateOnChange: true,
    onSubmit: onDelete,
  });

  return (
    <div className={styles.wrapper}>
      <img src={Logo} alt={"stroynik"} />
      <div className={styles.deleteForm}>
        <h2 className={styles.title}>Delete Account</h2>
        <p className={styles.description}>
          Enter your email and password to permanently delete your account.
        </p>
        <Input
          id="email"
          value={values.email}
          onChange={handleChange}
          label={"Email"}
          placeholder={"example@gmail.com"}
          wrapperStyles={styles.input}
          error={touched.email && errors.email}
        />
        <Input
          id="password"
          value={values.password}
          onChange={handleChange}
          label={"Password"}
          isShow
          placeholder={"Password"}
          type={"password"}
          wrapperStyles={styles.input}
          error={touched.password && errors.password}
        />
        <Button
          loading={isLoading}
          onClick={() => handleSubmit()}
          style={{ borderRadius: "16px", backgroundColor: "#ff4d4f" }}
          title={"Delete Account"}
          styleType={"filled"}
        />
        {error && <p className={styles.error}>{error}</p>}
      </div>
    </div>
  );
};

export default DeleteAccount;
